"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var EncoderFormat;
(function (EncoderFormat) {
    EncoderFormat[EncoderFormat["Text"] = 0] = "Text";
    EncoderFormat[EncoderFormat["Hexadecimal"] = 1] = "Hexadecimal";
    EncoderFormat[EncoderFormat["Base64"] = 2] = "Base64";
})(EncoderFormat = exports.EncoderFormat || (exports.EncoderFormat = {}));
//# sourceMappingURL=createDeeplinkArgs.js.map